import { useAtom } from 'jotai'
import { useLocation, useSearchParams } from 'react-router-dom'
import { PAGE_LIMIT } from 'src/common/apollo/hooks/useOffers'
import useEffectCompare from 'src/common/hooks/helpers/useEffectCompare'
import { Offer } from 'src/common/types/models/Offer'
import InfiniteList from 'src/common/ui-kit/InfiniteList/InfiniteList'
import Skeleton from 'src/common/ui-kit/Skeleton/Skeleton'
import {
  preselectedMyOfferIdAtom,
  sharedOfferAtom,
} from 'src/pages/DiscoverPage/discover-store'
import OfferRow from '../OfferRow/OfferRow'
import ShareOfferModal from '../ShareOffer/ShareOfferModal'
import OffersNoResults from './OffersNoResults'

interface OffersListProps {
  offers: Offer[]
}

const OffersList: React.FC<OffersListProps> = ({ offers }) => {
  const [searchParams] = useSearchParams()
  const skeletonCount = offers.length === 0 ? PAGE_LIMIT : 2
  const [sharedOffer, setSharedOffer] = useAtom(sharedOfferAtom)
  const [preselectedMyOfferId, setPreselectedMyOfferId] = useAtom(
    preselectedMyOfferIdAtom
  )
  const location = useLocation()

  useEffectCompare(() => {
    setPreselectedMyOfferId(null)
  }, [location])

  return (
    <>
      <div className='flex flex-col space-y-2'>
        <InfiniteList
          loader={<Skeleton height={64} count={skeletonCount} />}
          noResults={<OffersNoResults />}
        >
          {offers.map(offer => (
            <OfferRow
              key={offer.id}
              offer={offer}
              initialDetails={
                searchParams.get('id') === offer.id ||
                preselectedMyOfferId === offer.id
              }
            />
          ))}
        </InfiniteList>
      </div>
      <ShareOfferModal
        offer={sharedOffer}
        open={!!sharedOffer}
        onClose={() => setSharedOffer(null)}
      />
    </>
  )
}

export default OffersList
